import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { completeAdminRegistration } from "../Apis/SuperadminApis";
import "./AdminRegistration.css";
import PopupMessage from "../PopupMessage/PopupMessage";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AdminRegistration = () => {
  const { link } = useParams();
  const navigate = useNavigate();
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  
  const [formData, setFormData] = useState({
    name: "",
    contact_name: "",
    mobile_no: "",
    country_code: "",
    password: "",
    re_password: "",
    address: "",
    landmark: "",
    pincode: "",
    pilots: "",
    drones: ""
  });
  const [locationData, setLocationData] = useState({
    mandal: "",
    district: "",
    city: "",
    state: ""
  });
  const [isLookingUpPincode, setIsLookingUpPincode] = useState(false);
  const [files, setFiles] = useState({
    logo: null,
    gst_file: null
  });
  const [previews, setPreviews] = useState({
    logo: null,
    gst_file: null
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  
  useEffect(() => {
    if (!link) {
      setPopupMessage("Invalid registration link");
      setPopupType("error");
      setPopupOpen(true);
    }
  }, [link]);
  
  const fetchLocationFromPincode = async (pincode) => {
    if (!pincode || pincode.length !== 6) {
      return;
    }
    
    setIsLookingUpPincode(true);
    try {
      const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await response.json();
      
      if (data && data[0] && data[0].Status === "Success") {
        const postOffices = data[0].PostOffice;
        if (postOffices && postOffices.length > 0) {
          const po = postOffices[0];
          setLocationData({
            mandal: po.Block || "N/A",
            district: po.District || "N/A",
            city: po.District || "N/A", 
            state: po.State || "N/A"
          });
          setPopupMessage("Location details fetched successfully!");
          setPopupType("success");
          setPopupOpen(true);
          setTimeout(() => setPopupOpen(false), 2000);
        } else {
          setLocationData({ mandal: "", district: "", city: "", state: "" });
          setPopupMessage("No location found for this pincode");
          setPopupType("error");
          setPopupOpen(true);
        }
      } else {
        setLocationData({ mandal: "", district: "", city: "", state: "" });
        setPopupMessage("Invalid pincode");
        setPopupType("error");
        setPopupOpen(true);
      }
    } catch (error) {
      console.error("Error fetching pincode details:", error);
      setLocationData({ mandal: "", district: "", city: "", state: "" });
      setPopupMessage("Error fetching location details");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setIsLookingUpPincode(false);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (name === "password") {
      checkPasswordStrength(value);
    }
    if (name === "pincode" && value.length === 6 && /^\d+$/.test(value)) {
      fetchLocationFromPincode(value);
    }
    if (name === "pincode" && value.length !== 6) {
      setLocationData({ mandal: "", district: "", city: "", state: "" });
    }
  };
  
  const checkPasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (password.match(/[a-z]/)) strength++;
    if (password.match(/[A-Z]/)) strength++;
    if (password.match(/[0-9]/)) strength++;
    if (password.match(/[^a-zA-Z0-9]/)) strength++;
    setPasswordStrength(strength);
  };
  
  const getPasswordStrengthText = () => {
    if (passwordStrength === 0) return "No password";
    if (passwordStrength <= 2) return "Weak";
    if (passwordStrength === 3) return "Medium";
    if (passwordStrength >= 4) return "Strong";
    return "";
  };
  
  const getPasswordStrengthColor = () => {
    if (passwordStrength <= 2) return "#e74c3c";
    if (passwordStrength === 3) return "#f39c12";
    if (passwordStrength >= 4) return "#27ae60";
    return "#95a5a6";
  };
  
  const handleFileChange = (e) => {
    const { name, files: fileList } = e.target;
    const file = fileList[0];
    
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setPopupMessage("File size should be less than 5MB");
        setPopupType("error");
        setPopupOpen(true);
        return;
      }
      
      setFiles(prev => ({
        ...prev,
        [name]: file
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews(prev => ({
          ...prev,
          [name]: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  
  const validateForm = () => {
    const requiredFields = ['name', 'contact_name', 'mobile_no', 'password', 're_password', 'pincode'];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        setPopupMessage(`Please fill in the ${field.replace('_', ' ')} field`);
        setPopupType("error");
        setPopupOpen(true);
        return false;
      }
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name)) {
      setPopupMessage("Name should contain only letters and spaces");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    if (!nameRegex.test(formData.contact_name)) {
      setPopupMessage("Contact name should contain only letters and spaces");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

const phoneRegex = /^[0-9]{10,15}$/;
if (!phoneRegex.test(formData.mobile_no)) {
  setPopupMessage("Please enter a valid mobile number");
  setPopupType("error");
  setPopupOpen(true);
  return false;
}

    if (formData.password.length < 6) {
      setPopupMessage("Password must be at least 6 characters long");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    if (formData.password !== formData.re_password) {
      setPopupMessage("Passwords do not match");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    if (!formData.pincode || !/^[0-9]{6}$/.test(formData.pincode)) {
      setPopupMessage("Please enter a valid 6-digit pincode");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }
    if (!locationData.state || locationData.state === "N/A") {
      setPopupMessage("Please enter a valid pincode to fetch location details");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    if (formData.pilots && isNaN(formData.pilots)) {
      setPopupMessage("Number of pilots must be a number");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    if (formData.drones && isNaN(formData.drones)) {
      setPopupMessage("Number of drones must be a number");
      setPopupType("error");
      setPopupOpen(true);
      return false;
    }

    return true;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setIsLoading(true);
      
      const formDataObj = new FormData();
      formDataObj.append('name', formData.name.toUpperCase());
      formDataObj.append('contact_name', formData.contact_name);
      formDataObj.append('mobile_no', formData.mobile_no);
      formDataObj.append('country_code', formData.country_code);
      formDataObj.append('password', formData.password);
      formDataObj.append('re_password', formData.re_password);
      if (formData.address) formDataObj.append('address', formData.address);
      if (formData.landmark) formDataObj.append('landmark', formData.landmark);
      if (formData.pincode) formDataObj.append('pincode', formData.pincode);
      if (formData.pilots) formDataObj.append('pilots', formData.pilots);
      if (formData.drones) formDataObj.append('drones', formData.drones);
      if (files.logo) formDataObj.append('logo', files.logo);
      if (files.gst_file) formDataObj.append('gst_file', files.gst_file);

      const response = await completeAdminRegistration(link, formDataObj);

      if (response.error) {
        setPopupMessage(response.error);
        setPopupType("error");
        setPopupOpen(true);
      } else if (response.message) {
        setPopupMessage(response.message);
        setPopupType("success");
        setPopupOpen(true);
        
        console.log("Registration successful:", response.data);
        
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      setPopupMessage(err.response?.data?.error || "Failed to complete registration. Please try again.");
      setPopupType("error");
      setPopupOpen(true);
      console.error("Registration error:", err);
    } finally {
      setIsLoading(false);
    }
  };
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  
  return (
    <>
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
      <div className="admin-registration-wrapper">
        <div className="admin-registration-container">
          <div className="admin-registration-card">
            <div className="admin-registration-header">
              <h1 className="admin-registration-title">Complete Admin Registration</h1>
              <p className="admin-registration-subtitle">
                Please fill in the details below to complete your registration
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="admin-registration-form">
              <div className="admin-registration-form-group">
                <label htmlFor="name" className="admin-registration-label">
                  Organization Name <span className="admin-registration-required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter organization name"
                  className="admin-registration-input"
                  disabled={isLoading}
                />
                <div className="admin-registration-hint">
                  This will be displayed as your organization's name
                </div>
              </div>
              
              <div className="admin-registration-form-group">
                <label htmlFor="contact_name" className="admin-registration-label">
                  Contact Person Name <span className="admin-registration-required">*</span>
                </label>
                <input
                  type="text"
                  id="contact_name"
                  name="contact_name"
                  value={formData.contact_name}
                  onChange={handleInputChange}
                  placeholder="Enter contact person name"
                  className="admin-registration-input"
                  disabled={isLoading}
                />
              </div>
              
              <div className="admin-registration-form-group">
                <label htmlFor="mobile_no" className="admin-registration-label">
                  Mobile Number <span className="admin-registration-required">*</span>
                </label>
               <PhoneInput
  country={"in"}
  value={formData.mobile_no}
  onChange={(phone, countryData) =>
    setFormData((prev) => ({
      ...prev,
      mobile_no: phone,
      country_code: countryData.dialCode   
    }))
  }
  inputClass="admin-registration-input"
  containerClass="phone-input-container"
  enableSearch={true}
  placeholder="Enter mobile number"
  disabled={isLoading}
/>
              </div>
              
              <div className="admin-registration-form-group">
                <label htmlFor="password" className="admin-registration-label">
                  Password <span className="admin-registration-required">*</span>
                </label>
                <div className="admin-registration-password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Create a password"
                    className="admin-registration-input"
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="admin-registration-password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
                {formData.password && (
                  <div className="admin-registration-password-strength">
                    <div className="admin-registration-strength-bar">
                      <div 
                        className="admin-registration-strength-fill"
                        style={{ 
                          width: `${(passwordStrength / 5) * 100}%`,
                          backgroundColor: getPasswordStrengthColor()
                        }}
                      ></div>
                    </div>
                    <span style={{ color: getPasswordStrengthColor() }}>
                      Password Strength: {getPasswordStrengthText()}
                    </span>
                  </div>
                )}
                <div className="admin-registration-hint">
                  Password must be at least 6 characters with mix of letters, numbers, and symbols
                </div>
              </div>
              
              <div className="admin-registration-form-group">
                <label htmlFor="re_password" className="admin-registration-label">
                  Confirm Password <span className="admin-registration-required">*</span>
                </label>
                <div className="admin-registration-password-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="re_password"
                    name="re_password"
                    value={formData.re_password}
                    onChange={handleInputChange}
                    placeholder="Confirm your password"
                    className="admin-registration-input"
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="admin-registration-password-toggle"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
              </div>
<div className="admin-registration-form-group admin-registration-half">
                  <label htmlFor="pincode" className="admin-registration-label">
                    Pincode <span className="admin-registration-required">*</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="Enter 6-digit pincode"
                    className="admin-registration-input"
                    maxLength="6"
                    disabled={isLoading || isLookingUpPincode}
                  />
                  {isLookingUpPincode && (
                    <div className="admin-registration-loading">Fetching location...</div>
                  )}
                </div>
              <div className="admin-registration-location-section">
                <div className="admin-registration-section-title">
                  <span>📍 Location Details (Auto-fetched from Pincode)</span>
                </div>
                
                <div className="admin-registration-row">
                  <div className="admin-registration-form-group admin-registration-half">
                    <label htmlFor="mandal" className="admin-registration-label">
                      Mandal/Block
                    </label>
                    <input
                      type="text"
                      id="mandal"
                      value={locationData.mandal}
                      className="admin-registration-input admin-registration-readonly"
                      readOnly
                      disabled
                      placeholder="Auto-filled from pincode"
                    />
                  </div>

                  <div className="admin-registration-form-group admin-registration-half">
                    <label htmlFor="city" className="admin-registration-label">
                      City
                    </label>
                    <input
                      type="text"
                      id="city"
                      value={locationData.city}
                      className="admin-registration-input admin-registration-readonly"
                      readOnly
                      disabled
                      placeholder="Auto-filled from pincode"
                    />
                  </div>
                </div>

                <div className="admin-registration-row">
                  <div className="admin-registration-form-group admin-registration-half">
                    <label htmlFor="district" className="admin-registration-label">
                      District
                    </label>
                    <input
                      type="text"
                      id="district"
                      value={locationData.district}
                      className="admin-registration-input admin-registration-readonly"
                      readOnly
                      disabled
                      placeholder="Auto-filled from pincode"
                    />
                  </div>

                  <div className="admin-registration-form-group admin-registration-half">
                    <label htmlFor="state" className="admin-registration-label">
                      State <span className="admin-registration-required">*</span>
                    </label>
                    <input
                      type="text"
                      id="state"
                      value={locationData.state}
                      className="admin-registration-input admin-registration-readonly"
                      readOnly
                      disabled
                      placeholder="Auto-filled from pincode"
                    />
                  </div>
                </div>
              </div>

              
              
               <div className="admin-registration-form-group">
                <label htmlFor="address" className="admin-registration-label">
                  Address
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="Enter organization address"
                  className="admin-registration-textarea"
                  rows="3"
                  disabled={isLoading}
                />
              </div>
 <div className="admin-registration-row">
                <div className="admin-registration-form-group admin-registration-half">
                  <label htmlFor="landmark" className="admin-registration-label">
                    Landmark
                  </label>
                  <input
                    type="text"
                    id="landmark"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    placeholder="Enter landmark"
                    className="admin-registration-input"
                    disabled={isLoading}
                  />
                </div>

                
              </div>

              <div className="admin-registration-row">
                <div className="admin-registration-form-group admin-registration-half">
                  <label htmlFor="pilots" className="admin-registration-label">
                    Number of Pilots
                  </label>
                  <input
                    type="number"
                    id="pilots"
                    name="pilots"
                    value={formData.pilots}
                    onChange={handleInputChange}
                    placeholder="Enter number of pilots"
                    className="admin-registration-input"
                    min="0"
                    disabled={isLoading}
                  />
                </div>
                
                <div className="admin-registration-form-group admin-registration-half">
                  <label htmlFor="drones" className="admin-registration-label">
                    Number of Drones
                  </label>
                  <input
                    type="number"
                    id="drones"
                    name="drones"
                    value={formData.drones}
                    onChange={handleInputChange}
                    placeholder="Enter number of drones"
                    className="admin-registration-input"
                    min="0"
                    disabled={isLoading}
                  />
                </div>
              </div>
              
              <div className="admin-registration-file-row">
                <div className="admin-registration-file-group">
                  <label htmlFor="logo" className="admin-registration-label">
                    Organization Logo <span className="admin-registration-required">*</span>
                  </label>
                  <div className="admin-registration-file-upload">
                    <input
                      type="file"
                      id="logo"
                      name="logo"
                      onChange={handleFileChange}
                      accept="image/*"
                      className="admin-registration-file-input"
                      disabled={isLoading}
                    />
                    <label htmlFor="logo" className="admin-registration-file-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
                      </svg>
                      Choose Logo
                    </label>
                    <span className="admin-registration-file-hint">
                      JPG/PNG (Max 5MB)
                    </span>
                  </div>
                  {previews.logo && (
                    <div className="admin-registration-preview">
                      <img src={previews.logo} alt="Logo Preview" className="admin-registration-preview-img" />
                      <button
                        type="button"
                        className="admin-registration-preview-remove"
                        onClick={() => {
                          setFiles(prev => ({ ...prev, logo: null }));
                          setPreviews(prev => ({ ...prev, logo: null }));
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>

                <div className="admin-registration-file-group">
                  <label htmlFor="gst_file" className="admin-registration-label">
                    GST Certificate
                  </label>
                  <div className="admin-registration-file-upload">
                    <input
                      type="file"
                      id="gst_file"
                      name="gst_file"
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                      className="admin-registration-file-input"
                      disabled={isLoading}
                    />
                    <label htmlFor="gst_file" className="admin-registration-file-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
                      </svg>
                      Upload GST
                    </label>
                    <span className="admin-registration-file-hint">
                      PDF/Image (Max 5MB)
                    </span>
                  </div>
                  {previews.gst_file && (
                    <div className="admin-registration-preview">
                      {previews.gst_file.includes('pdf') ? (
                        <div className="admin-registration-preview-pdf">
                          📄 PDF Document
                        </div>
                      ) : (
                        <img src={previews.gst_file} alt="GST Preview" className="admin-registration-preview-img" />
                      )}
                      <button
                        type="button"
                        className="admin-registration-preview-remove"
                        onClick={() => {
                          setFiles(prev => ({ ...prev, gst_file: null }));
                          setPreviews(prev => ({ ...prev, gst_file: null }));
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              </div>
              
              <button
                type="submit"
                className="admin-registration-submit-btn"
                disabled={isLoading || isLookingUpPincode || !locationData.state}
              >
                {isLoading ? (
                  <>
                    <svg className="admin-registration-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeDasharray="31.4 31.4" fill="none"/>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  "Complete Registration"
                )}
              </button>
            </form>
            
            <div className="admin-registration-footer">
              <p>
                Already have an account? <a href="/login">Login here</a>
              </p>
              <p className="admin-registration-disclaimer">
                By registering, you agree to our Terms of Service and Privacy Policy
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminRegistration;